module.exports = __webpack_public_path__ + "media/images/image6-46516c531250e78a1806cfdf082ef5c8.png";